import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SortDataService {

  constructor() {
  }

  /**
   * Sorts an array of objects generically by a specified key.
   * @param array The array of objects to sort.
   * @param key The property name to sort by.
   * @param order The sort order ('asc' for ascending, 'desc' for descending).
   * @returns A new, sorted array of the same type.
   */
  public sortArray<T extends object, K extends keyof T>(
    array: T[],
    key: K,
    order: 'asc' | 'desc' = 'asc'
  ): T[] {
    if (!array || array.length === 0) {
      return [];
    }

    // Return a new array instead of modifying the original
    return [...array].sort((a, b) => {
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return order === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }
}
